/** Joins class names, skipping falsy values (the kit's cn() without Tailwind merging). */
export function cn(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
